var React = require('react');

function ScheduledMessage (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.993 21.183a1.272 1.272 0 01-2.308.048l-2.279-4.606 7.613-8.7-8.655 7.573-4.678-2.468a1.296 1.296 0 01.092-2.33l15.39-6.597c.65-.278 1.4.027 1.675.683.139.33.135.705-.01 1.033L18.3 11.506l-.039-.009a4.752 4.752 0 01-1.012 9.392 4.728 4.728 0 01-2.74-.87l-.517 1.164zm3.257-8.607a3.563 3.563 0 100 7.125 3.563 3.563 0 000-7.125zm-.155.924c.206 0 .372.167.372.373v2.182l1.235 1.088a.31.31 0 01.028.436l-.028.028a.399.399 0 01-.527 0l-1.317-1.16a.308.308 0 01-.104-.215.382.382 0 01-.032-.151v-2.208c0-.206.167-.373.373-.373z","fill":"currentColor","fillRule":"nonzero"}));
}

ScheduledMessage.defaultProps = {"width":"16","height":"16","viewBox":"2 2 22 22"};

module.exports = ScheduledMessage;

ScheduledMessage.default = ScheduledMessage;
